import React, { useRef } from "react";

// React wrapper for Om Design System SelectOption web component
const OmSelectOption = React.forwardRef(({ 
  children,
  value,
  ...props 
}, ref) => {
  const elementRef = useRef(null);

  return (
    <omk-select-option
      ref={(el) => {
        elementRef.current = el;
        if (ref) {
          if (typeof ref === 'function') {
            ref(el);
          } else {
            ref.current = el;
          }
        }
      }}
      value={value}
      {...props}
    >
      {children}
    </omk-select-option>
  );
});

OmSelectOption.displayName = 'OmSelectOption';

export default OmSelectOption;
